import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import ColourPickerControl from './ColourPickerControl.js';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';

const styles = theme => ({
    button: {
        margin: theme.spacing.unit
    }
});

const defaultColour = '#666666';
class ColourPickerModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentColour: '',
            changed: false
        };
    }


    handleClose = () => {
        console.log('handle close');
        this.props.modalClose(this.state.currentColour, false);
        this.setState({changed: false});
    };

    handleClickOK = () => {
        if (this.state.changed) {
            this.props.modalClose(this.state.currentColour, true);
            this.setState({changed: false});
        } else {
            this.handleClose();
        }

    };
    handleClickReset = () => {

        if (this.state.changed) {
            this.props.modalClose(this.state.currentColour, true);
            this.setState({changed: false});
        } else {
            this.handleClose();
        }

    };

    handleChange = (color) => {
        if (color !== '') {
            this.setState({
                currentColour: color.hex,
                changed: true
            });
        } else {
            this.setState({
                currentColour: '',
                changed: true
            });
        }

    };

    handleNoColourClick = (event) => {
        console.log('handle no colour click');
        let checked = event.target.checked;

        if (checked) {
            this.handleChange('');
        } else {
            this.handleChange({hex: defaultColour}); // default colour if uncheck
        }
    };


    render() {
        const { colour, classes, open, onClickReset } = this.props;
        const { currentColour, changed } = this.state;

        let colourToShow = changed ? currentColour : colour;

        let noColour = colourToShow === '';

        return (
            <Dialog onClose={this.handleClose} style={{textAlign:'center', padding: 8}} open={open}>
                <DialogTitle>Pick a colour</DialogTitle>
                <div >
                    <Checkbox checked={ noColour } color='primary' onChange={ this.handleNoColourClick } /> No Colour<br />
                    {!noColour && <ColourPickerControl color={colourToShow} onChange={ this.handleChange } /> }
                    {!noColour && <div style={{ height: 100, backgroundColor: currentColour, margin: 20, borderRadius: 5 }}></div>}
                    <div>
                        <Button variant="contained" className={classes.button} onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="contained" color="primary" className={classes.button} onClick={this.handleClickOK}>
                            OK
                        </Button>
                        {onClickReset != null && <Button variant="contained" color="seconadry" className={classes.button} onClick={onClickReset}>
                            Reset
                        </Button>}
                    </div>
                </div>
            </Dialog>
        );
    }
}

const ColourPickerModalWrapper = withStyles(styles)(ColourPickerModal);
export default ColourPickerModalWrapper;

